import { createSelector } from 'reselect';

const selectDomain = (state) => state.push;

export const selectPushStatus = createSelector([selectDomain], (state) => state.get('status'));
export const selectPushBusy = createSelector([selectDomain], (state) => state.get('busy'));
export const selectPushError = createSelector([selectDomain], (state) => state.get('error'));
